 export const getRankIcon = (rank) => {
    switch (rank) {
      case 1:
        return <span style={{ fontSize: "1.6rem" }}>🥇</span>;
      case 2:
        return <span style={{ fontSize: "1.4rem" }}>🥈</span>;
      case 3:
        return <span style={{ fontSize: "1.2rem" }}>🥉</span>;
      default:
        return (
          <span
            className="fw-bold text-muted font-monospace"
            style={{ fontSize: "1.1rem" }}
          >
            #{rank}
          </span>
        );
    }
  };